export { default } from '../../../menu/(menu)/[slug]/_layout';
export * from '../../../menu/(menu)/[slug]/_layout';
